/* LOOV: buy box (Standard + Direct), LOOV Circle consent (Standard), membership guard, quick add, sheets.
   See snippets/loov-consent.liquid, snippets/loov-pdp-mode.liquid and sections/loov-product.liquid.

   Purchase module (one for Standard, Direct and quick add):
   - Jewelry is always a one-time purchase. Member prices = the product's "VIP Price" variant.
   - A member purchase adds the VIP jewelry plus ONE LOOV Circle membership product per cart
     (snippets/loov-membership). The membership is the only line carrying a selling plan; the
     plan is resolved from the plans on the membership variant, intersected with the plans Revley
     is configured for (data-revley-selling-plan-ids on Revley's script tag). Never hard-coded.
   - Standard pages record consent on the membership line (_loov_circle_consent). Direct pages:
     select bundle, Add to cart, Revley checkout; Revley's checkout takes the consent.
   - Cart rules (normalizeCart, run after every cart change): jewelry never carries a plan; one
     membership, quantity 1, with the plan; member-priced jewelry without a membership goes back
     to regular ("Guest Price") prices; a membership added by these pages with no member-priced
     jewelry left is removed.
   - Checkout is held if the cart still breaks those rules (never sent through as one-time).
   - Analytics: one AddToCart per shopper action (see quietFetch). */
(function () {
  if (window.__loovDS) return;
  window.__loovDS = true;

  var C = window.LoovDS || {};
  var ROOT = C.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_URL = C.cartUrl || ROOT + 'cart';
  var M = C.membership || null;   // LOOV Circle membership product (snippets/loov-membership)
  var realFetch = window.fetch.bind(window);

  /* ---------- helpers ---------- */
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function log() { try { console.info.apply(console, ['[LOOV]'].concat([].slice.call(arguments))); } catch (e) {} }

  function fetchCart() {
    return realFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  /* Analytics: Shopify's web pixels (Meta, TikTok and Shopify's own analytics) watch window.fetch
     and report every line of a /cart/add.js call as its own product_added_to_cart event, and the
     lines added or removed by /cart/change.js as add/remove events. So that each shopper action
     sends exactly one AddToCart, only the shopper's own add (the jewelry) goes through
     window.fetch. Cart writes the shopper didn't make themselves (the LOOV Circle line that rides
     along with a member purchase, and the cart-rule repairs) go through quietFetch: the fetch of a
     blank same-origin frame, which the pixels don't watch. If the frame can't be made, a
     single-argument Request, which Shopify's add-to-cart detection doesn't report either. */
  var quietFrame = null;
  function quietFetch(url, init) {
    var abs = new URL(url, window.location.href).href;
    try {
      if (!quietFrame || !quietFrame.isConnected) {
        quietFrame = document.createElement('iframe');
        quietFrame.setAttribute('aria-hidden', 'true');
        quietFrame.setAttribute('tabindex', '-1');
        quietFrame.title = 'LOOV cart';
        quietFrame.style.display = 'none';
        (document.body || document.documentElement).appendChild(quietFrame);
      }
      var w = quietFrame.contentWindow;
      if (w && typeof w.fetch === 'function') return w.fetch(abs, init);
    } catch (e) {}
    return realFetch(new Request(abs, init));
  }
  function post(fetcher, path, body) {
    return fetcher(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not update the cart.');
        return data;
      });
    });
  }
  function postJSON(path, body) { return post(realFetch, path, body); }
  function postQuiet(path, body) { return post(quietFetch, path, body); }
  function membershipLines(cart) {
    var vid = M ? Number(M.variant) : 0;
    return ((cart && cart.items) || []).filter(function (it) { return !!vid && it.variant_id === vid; });
  }
  function hasMembership(cart) { return membershipLines(cart).length > 0; }
  function addItems(items) {
    // Goes through window.fetch on purpose, so the cart drawer and analytics see the add.
    return window.fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
        return data;
      });
    });
  }
  function openDrawer() {
    var drawer = document.querySelector('sugar-cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') { window.location.href = CART_URL; return Promise.resolve(); }
    return realFetch(CART_URL + '?sections=sugar-cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (sections) { drawer.renderContents({ id: null, sections: sections }); })
      .catch(function () { window.location.href = CART_URL; });
  }
  function consentRecord(terms) {
    return 'Agreed ' + new Date().toISOString() + ' on ' + window.location.pathname + ': ' + (terms || '');
  }
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'lv-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  function busy(btn, on) { if (btn) btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
  function money(cents) { return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, ''); }

  /* ---------- LOOV Circle plan resolution (Revley) ---------- */
  function gidNum(v) { var s = String(v == null ? '' : v).trim().split('/').pop(); return /^\d+$/.test(s) ? s : ''; }
  // Plans Revley is set up for, read from Revley's own script tag. null = Revley isn't on the page.
  function revleyPlans() {
    var el = document.querySelector('script[data-revley-selling-plan-ids]');
    if (!el) return null;
    try {
      var list = JSON.parse(el.getAttribute('data-revley-selling-plan-ids') || '[]');
      return (Array.isArray(list) ? list : []).map(gidNum).filter(Boolean);
    } catch (e) { return []; }
  }
  // productPlans: plan ids the VIP variant offers (from the page). Returns { plan } or { reason }.
  function resolvePlan(productPlans) {
    var rv = revleyPlans();
    if (rv === null) return { plan: 0, reason: 'revley_missing' };
    if (!rv.length) return { plan: 0, reason: 'revley_has_no_plans' };
    if (!productPlans.length) return { plan: 0, reason: 'no_selling_plan' };
    for (var i = 0; i < productPlans.length; i++) if (rv.indexOf(productPlans[i]) > -1) return { plan: Number(productPlans[i]) };
    return { plan: 0, reason: 'plan_not_in_revley' };
  }
  // The selling plan for the membership line: on the membership variant AND in Revley's list.
  function memberPlan() {
    if (!M || !M.variant) return { plan: 0, reason: 'no_membership_product' };
    return resolvePlan((M.plans || []).map(String));
  }
  function linePlan(item) { return item && item.selling_plan_allocation ? gidNum(item.selling_plan_allocation.selling_plan.id) : ''; }
  function sameProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a).filter(function (k) { return a[k] !== null && a[k] !== ''; }).sort();
    var kb = Object.keys(b).filter(function (k) { return b[k] !== null && b[k] !== ''; }).sort();
    if (ka.join('|') !== kb.join('|')) return false;
    return ka.every(function (k) { return String(a[k]) === String(b[k]); });
  }
  var CONFIG_MESSAGES = {
    no_vip_variant: 'the product has no "VIP Price" variant',
    no_selling_plan: 'the LOOV Circle membership product has no selling plan attached',
    no_membership_product: 'the LOOV Circle membership product (handle in snippets/loov-circle-terms) is missing or not available on the Online Store',
    membership_not_attached: 'Shopify did not add the LOOV Circle membership with its selling plan, so the member-priced piece was taken out again',
    revley_missing: 'the Revley checkout script is not on this page',
    revley_has_no_plans: 'Revley has no selling plans configured (data-revley-selling-plan-ids is empty)',
    plan_not_in_revley: 'the membership’s selling plan is not one Revley is configured for'
  };

  /* ---------- attribution (first and last touch, kept on the cart) ---------- */
  var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'];
  function touchFromUrl() {
    var q; try { q = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var parts = [];
    ATTR_KEYS.forEach(function (k) { var v = q.get(k); if (v) parts.push(k + '=' + v.slice(0, 120)); });
    if (!parts.length) return null;
    return parts.join('&') + ' | ' + window.location.pathname + ' | ' + new Date().toISOString().slice(0, 16);
  }
  (function captureTouch() {
    var t = touchFromUrl();
    if (!t) return;
    try {
      if (!localStorage.getItem('lv_first_touch')) localStorage.setItem('lv_first_touch', t);
      localStorage.setItem('lv_last_touch', t);
    } catch (e) {}
  })();
  function syncAttribution(cart) {
    var first = '', last = '';
    try { first = localStorage.getItem('lv_first_touch') || ''; last = localStorage.getItem('lv_last_touch') || ''; } catch (e) {}
    var attrs = (cart && cart.attributes) || {};
    var upd = {};
    if (first && !attrs._loov_first_touch) upd._loov_first_touch = first;
    if (last && attrs._loov_last_touch !== last) upd._loov_last_touch = last;
    if (!Object.keys(upd).length) return Promise.resolve();
    return postJSON('cart/update.js', { attributes: upd }).catch(function () {});
  }

  /* ---------- sheets ---------- */
  var lastFocus = null;
  function openSheet(id, opener) {
    var sheet = document.getElementById(id);
    if (!sheet) return;
    lastFocus = opener || document.activeElement;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var panel = $('.lv-sheet__panel', sheet);
    setTimeout(function () { if (panel) panel.focus(); }, 30);
  }
  function closeSheet(sheet) {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (!$('.lv-sheet.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lv-sheet-open]');
    if (opener) { e.preventDefault(); e.stopPropagation(); openSheet(opener.getAttribute('data-lv-sheet-open'), opener); return; }
    var closer = e.target.closest('[data-lv-sheet-close]');
    if (closer) { e.preventDefault(); closeSheet(closer.closest('.lv-sheet')); }
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-lv-scroll-buy]');
    if (!a) return;
    var buy = document.querySelector('[data-lv-buy]');
    if (!buy) return;
    e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var open = $$('.lv-sheet.is-open').pop(); if (open) closeSheet(open); }
  });

  /* ---------- consent block (standard product page and quick add) ---------- */
  function Consent(el) {
    this.el = el;
    this.box = $('[data-lv-consent-box]', el);
    this.terms = $('[data-terms]', el);
    var self = this;
    if (this.box) this.box.addEventListener('change', function () { if (self.box.checked) self.el.classList.remove('has-error'); });
  }
  Consent.prototype.setMember = function (on) { this.el.classList.toggle('is-member', !!on); };
  Consent.prototype.ok = function () { return !!(this.box && this.box.checked); };
  Consent.prototype.fail = function () {
    this.el.classList.add('has-error');
    this.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (this.box) this.box.focus({ preventScroll: true });
  };

  /* Member purchase (Standard, Direct, quick add): VIP jewelry as a one-time item, plus one LOOV
     Circle membership with its selling plan if the cart doesn't have one yet. memberProps go on the
     membership line (Standard: consent).
     1. The membership goes in first, quietly (not a shopper add, see quietFetch). If Shopify
        refuses it (e.g. no valid selling plan), nothing is added at all.
     2. Then the jewelry, through window.fetch: the one AddToCart analytics sees for this action.
        If the jewelry can't be added (e.g. stock), the membership just added is taken out again.
     3. Checks the membership really is in the cart with its plan; if not, both come back out.
     Cart rules wait until all of this is done (addLock), so they never see the halfway cart. */
  var addLock = null;
  function addMemberPurchase(vipId, qty, pdp, memberProps, expectedCents) {
    var mp = memberPlan();
    if (!mp.plan) { var e0 = new Error('config'); e0.reason = mp.reason; return Promise.reject(e0); }
    var vid = Number(vipId);
    var props = { _loov_pdp: pdp };
    var mprops = Object.assign({ _loov_pdp: pdp }, memberProps || {});
    var release, lock = new Promise(function (r) { release = r; });
    addLock = lock;
    function done() { if (addLock === lock) addLock = null; release(); scheduleRefresh(); }
    function configError() { var e = new Error('config'); e.reason = 'membership_not_attached'; return e; }
    // Takes out the membership line this purchase added (matched by its properties).
    function dropNewMembership() {
      return fetchCart().then(function (c) {
        var m = membershipLines(c).filter(function (l) { return sameProps(l.properties, mprops); })[0];
        return m ? postQuiet('cart/change.js', { id: m.key, quantity: 0 }) : null;
      }).catch(function () {});
    }
    var added = false;
    return fetchCart().then(function (cart) {
      var before = 0;
      (cart.items || []).forEach(function (l) { if (l.variant_id === vid && sameProps(l.properties, props) && !l.selling_plan_allocation) before = l.quantity; });
      var needMember = !hasMembership(cart);
      var step1 = needMember
        ? postQuiet('cart/add.js', { items: [{ id: Number(M.variant), quantity: 1, selling_plan: mp.plan, properties: mprops }] })
            .then(function () { added = true; }, function (err) { console.error('[LOOV] The LOOV Circle membership could not be added: ' + (err && err.message)); throw configError(); })
        : Promise.resolve();
      return step1.then(function () {
        return addItems([{ id: vid, quantity: Number(qty), properties: props }]).catch(function (err) {
          return (added ? dropNewMembership() : Promise.resolve()).then(function () { throw err; });
        });
      }).then(function () { return fetchCart(); }).then(function (after) {
        var ms = membershipLines(after);
        var ok = ms.length >= 1 && ms.some(function (l) { return linePlan(l) === String(mp.plan); });
        var line = (after.items || []).filter(function (l) { return l.variant_id === vid && sameProps(l.properties, props) && !l.selling_plan_allocation; })[0];
        if (!ok) {
          // The jewelry add was a shopper add, so its removal is reported too (window.fetch).
          var keep = Math.max(0, (line ? line.quantity : 0) - Number(qty));
          return (line ? post(function (u, i) { return window.fetch(u, i); }, 'cart/change.js', { id: line.key, quantity: keep }) : Promise.resolve()).catch(function () {})
            .then(function () { return added ? dropNewMembership() : null; })
            .then(function () { throw configError(); });
        }
        // The bundle price shown on the page should be what the cart charges for a fresh line.
        if (line && before === 0 && expectedCents && line.final_line_price !== Number(expectedCents)) {
          console.warn('[LOOV] Price check: the page showed ' + money(expectedCents) + ' but the cart charges ' + money(line.final_line_price) + ' for ' + line.quantity + ' × ' + line.product_title + '. Check the bundle discount on the product page matches the automatic discount in Shopify.');
        }
        return syncAttribution(after);
      });
    }).then(function (v) { done(); return v; }, function (err) { done(); throw err; });
  }
  function addOnce(variantId, qty, extra) {
    var item = { id: Number(variantId), quantity: Number(qty) };
    if (extra) item.properties = extra;
    return addItems([item]).then(function () { return fetchCart(); }).then(syncAttribution);
  }

  /* ---------- product page buy box ---------- */
  function initBuy(root) {
    if (root.__lv) return; root.__lv = true;
    var mode = root.getAttribute('data-mode') === 'direct' ? 'direct' : 'standard';
    var vip = root.getAttribute('data-vip');
    var guest = root.getAttribute('data-guest');
    var resolved = memberPlan();
    var consentEl = $('[data-lv-consent]', root);
    var consent = consentEl ? new Consent(consentEl) : null;
    var atc = $('[data-lv-atc]', root);
    var atcLabel = $('[data-lv-atc-label]', root);
    var guestBtn = $('[data-lv-guest]', root);
    var guestPrice = $('[data-lv-guest-price]', root);
    var status = $('[data-lv-status]', root);
    var sticky = document.querySelector('[data-lv-sticky="' + root.id + '"]');
    var stickySub = sticky && $('[data-lv-sticky-sub]', sticky);
    var stickyAtc = sticky && $('[data-lv-sticky-atc]', sticky);
    var stickyLabel = sticky && $('[data-lv-sticky-label]', sticky);
    var stockEl = $('[data-lv-stock]', root);
    var stock = null;
    try { stock = JSON.parse(root.getAttribute('data-stock') || 'null'); } catch (e) { stock = null; }
    var soldOut = root.getAttribute('data-sold-out') || 'Sold out';
    root.setAttribute('data-plan', resolved.plan || '');

    function current() {
      var input = $('input[name="lv-bundle"]:checked', root) || $('input[name="lv-bundle"]', root);
      return input ? {
        qty: Number(input.getAttribute('data-qty') || 1),
        label: input.getAttribute('data-label') || '',
        member: input.getAttribute('data-member-total') || '',
        cents: Number(input.getAttribute('data-member-cents') || 0),
        was: input.getAttribute('data-member-was') || '',
        guest: input.getAttribute('data-guest-total') || ''
      } : { qty: 1, label: '', member: root.getAttribute('data-member-price'), cents: Number(root.getAttribute('data-member-cents') || 0), was: '', guest: root.getAttribute('data-guest-price') };
    }
    /* Stock: the "In stock" line, Add to cart, the sticky bar and "buy once" follow live Shopify
       inventory for the variant being bought and the bundle size (rules: snippets/loov-stock). */
    function stockOf(v, qty) {
      if (!v || !v.available) return { state: 'out', left: 0 };
      if (v.tracked && v.deny) {
        if (v.left <= 0) return { state: 'out', left: 0 };
        if (v.left < qty) return { state: 'short', left: v.left };
        if (v.left <= Number(stock.low || 10)) return { state: 'low', left: v.left };
      }
      return { state: 'in', left: v.left };
    }
    function stockText(st) {
      var d = stockEl ? stockEl.dataset : {};
      if (st.state === 'out') return d.out || 'Sold out.';
      if (st.state === 'in') return d.in || 'In stock.';
      return String(d.low || 'Only [inventory] left.').replace(/\[inventory\]/g, st.left);
    }
    function bare(t) { return String(t).replace(/\.\s*$/, ''); }
    function applyStock(c) {
      var blocked = !!root.getAttribute('data-config-error');
      var main = stock ? stockOf(stock.vip, c.qty) : { state: 'in', left: 0 };
      var text = stockText(main);
      $$('[data-lv-stock-dot]', root).concat(sticky ? $$('[data-lv-stock-dot]', sticky) : []).forEach(function (dot) {
        dot.classList.toggle('is-low', main.state === 'low' || main.state === 'short');
        dot.classList.toggle('is-out', main.state === 'out');
      });
      $$('[data-lv-stock-eta]', root).concat(sticky ? $$('[data-lv-stock-eta]', sticky) : []).forEach(function (el) { el.hidden = main.state === 'out'; });
      if (stockEl) { stockEl.setAttribute('data-state', main.state); var head = $('[data-lv-stock-head]', stockEl); if (head) head.textContent = text; }
      var stickyStock = sticky && $('[data-lv-sticky-stock]', sticky);
      if (stickyStock) stickyStock.textContent = bare(text);
      var off = blocked || main.state === 'out' || main.state === 'short';
      [atc, stickyAtc].forEach(function (b) { if (b) { b.disabled = off; if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); } });
      if (atcLabel && !blocked) {
        atcLabel.textContent = main.state === 'out' ? soldOut : main.state === 'short' ? bare(text) : (atcLabel.getAttribute('data-prefix') || 'Add to cart') + ' · ' + c.member;
      }
      if (stickyLabel && !blocked) stickyLabel.textContent = main.state === 'out' ? soldOut : 'Add to cart';
      if (guestBtn) {
        var g = stock ? stockOf(stock.guest, c.qty) : { state: 'in' };
        var gOff = g.state === 'out' || g.state === 'short';
        guestBtn.disabled = gOff;
        if (guestPrice) guestPrice.textContent = gOff ? (g.state === 'out' ? soldOut : bare(stockText(g))) : c.guest;
      }
    }
    // Inventory can change while the page is open: re-read it from Shopify when the shopper comes back.
    var stockReadAt = Date.now();
    function refreshStock() {
      if (!stock || Date.now() - stockReadAt < 60000) return;
      stockReadAt = Date.now();
      var section = root.id.replace(/^LvBuy-/, '');
      var view = new URLSearchParams(window.location.search).get('view');
      realFetch(window.location.pathname + '?section_id=' + encodeURIComponent(section) + (view ? '&view=' + encodeURIComponent(view) : ''), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('section'); return r.text(); })
        .then(function (html) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lv-buy][data-stock]');
          if (!el) return;
          stock = JSON.parse(el.getAttribute('data-stock'));
          render();
        }).catch(function () {});
    }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshStock(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { stockReadAt = 0; refreshStock(); } });

    function render() {
      var c = current();
      applyStock(c);
      if (stickySub) {
        stickySub.innerHTML = '';
        var b = document.createElement('b'); b.textContent = c.member;
        stickySub.appendChild(document.createTextNode(c.label ? c.label + ' · ' : ''));
        stickySub.appendChild(b);
        if (c.was) { var s = document.createElement('s'); s.textContent = c.was; stickySub.appendChild(document.createTextNode(' ')); stickySub.appendChild(s); }
      }
    }
    $$('input[name="lv-bundle"]', root).forEach(function (i) { i.addEventListener('change', render); });
    render();

    function say(msg) { if (status) status.textContent = msg || ''; }

    /* Configuration errors block the Direct flow: never sell one-time from a Direct page. */
    function configError(reason) {
      var msg = CONFIG_MESSAGES[reason] || reason;
      root.setAttribute('data-config-error', reason);
      [atc, stickyAtc].forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); } });
      if (atcLabel) atcLabel.textContent = 'Not available on this page';
      if (stickyLabel) stickyLabel.textContent = 'Not available';
      console.error('[LOOV Direct] Configuration error on "' + root.getAttribute('data-product') + '": ' + msg + '. The Direct add to cart is disabled until this is fixed.');
      if (status) {
        status.innerHTML = '';
        status.appendChild(document.createTextNode('This piece can’t be bought on this page right now. '));
        var a = document.createElement('a'); a.href = (window.location.pathname.replace(/^.*\/products\//, ROOT + 'products/')); a.textContent = 'Shop it here'; status.appendChild(a);
        status.appendChild(document.createTextNode('.'));
        var debug = (window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main'))) || /lv_debug/.test(window.location.search);
        if (debug) { var d = document.createElement('span'); d.className = 'lv-status__debug'; d.textContent = ' Setup check: ' + msg + '.'; status.appendChild(d); }
      }
    }

    if (mode === 'direct') {
      var serverError = root.getAttribute('data-config-error');
      if (serverError) configError(serverError);
      else if (!resolved.plan) configError(resolved.reason);
      var directAdd = function (btn) {
        if (root.getAttribute('data-config-error')) return;
        say('');
        busy(btn, true);
        var c = current();
        addMemberPurchase(vip, c.qty, 'direct', null, c.cents).then(function () {
          busy(btn, false);
          return openDrawer();
        }).catch(function (err) {
          busy(btn, false);
          if (err && err.reason) configError(err.reason); else say(err.message);
        });
      };
      if (atc) atc.addEventListener('click', function (e) { e.preventDefault(); directAdd(atc); });
      if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); directAdd(stickyAtc); });
    } else {
      /* Member price unavailable (membership not set up): block the member add, keep "buy once". */
      var memberUnavailable = function (reason) {
        var msg = CONFIG_MESSAGES[reason] || reason;
        root.setAttribute('data-config-error', reason);
        [atc, stickyAtc].forEach(function (b) { if (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); } });
        if (atcLabel) atcLabel.textContent = 'Member price unavailable';
        if (stickyLabel) stickyLabel.textContent = 'Unavailable';
        console.error('[LOOV] Member purchase blocked on "' + root.getAttribute('data-product') + '": ' + msg + '.');
        say(guestBtn ? 'Member pricing isn’t available right now. You can still buy at the regular price below.' : 'Member pricing isn’t available right now.');
      };
      var memberAdd = function (btn) {
        say('');
        if (!vip) return;
        if (!resolved.plan) { memberUnavailable(resolved.reason); return; }
        busy(btn, true);
        var c = current();
        fetchCart().then(function (cart) {
          var member = hasMembership(cart);
          if (consent) consent.setMember(member);
          if (!member && consent && !consent.ok()) { consent.fail(); return false; }
          var props = member ? null : { _loov_circle_consent: consentRecord(consent && consent.terms && consent.terms.getAttribute('data-terms')) };
          return addMemberPurchase(vip, c.qty, 'standard', props, c.cents).then(function () { if (consent) consent.setMember(true); return true; });
        }).then(function (added) {
          busy(btn, false);
          if (added) return openDrawer();
        }).catch(function (err) { busy(btn, false); if (err && err.reason) memberUnavailable(err.reason); else say(err.message); });
      };
      if (!resolved.plan) console.error('[LOOV] Member purchases are unavailable: ' + (CONFIG_MESSAGES[resolved.reason] || resolved.reason) + '.');
      if (atc) atc.addEventListener('click', function (e) { e.preventDefault(); memberAdd(atc); });
      if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); memberAdd(stickyAtc); });
      if (guestBtn) guestBtn.addEventListener('click', function (e) {
        e.preventDefault();
        say('');
        busy(guestBtn, true);
        addOnce(guest, current().qty, { _loov_pdp: 'standard' }).then(function () { busy(guestBtn, false); return openDrawer(); })
          .catch(function (err) { busy(guestBtn, false); say(err.message); });
      });
      if (consent) {
        consent.setMember(root.getAttribute('data-member-cart') === 'true');
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'visible') fetchCart().then(function (c) { consent.setMember(hasMembership(c)); }).catch(function () {});
        });
      }
    }

    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(atc);
    }
  }

  /* ---------- cart rules: one membership, one-time jewelry, checkout held if broken ---------- */
  var cartState = null;      // last /cart.js seen
  var refreshing = null;     // in-flight refresh promise
  function isVipLine(l) { return !!l && l.variant_title === 'VIP Price'; }

  // First thing in the cart that breaks the rules, or null.
  function cartIssue(cart) {
    var items = (cart && cart.items) || [];
    var mvid = M ? Number(M.variant) : 0;
    var mp = memberPlan();
    var ms = membershipLines(cart);
    var vip = items.filter(isVipLine);
    var planJewelry = items.filter(function (l) { return l.selling_plan_allocation && l.variant_id !== mvid; });
    if (planJewelry.length) return { type: 'jewelry_plan', line: planJewelry[0] };
    if (ms.length > 1) return { type: 'extra_membership', line: ms[ms.length - 1] };
    if (ms.length === 1 && mp.plan && (ms[0].quantity !== 1 || linePlan(ms[0]) !== String(mp.plan))) return { type: 'fix_membership', line: ms[0] };
    if (vip.length && !ms.length && M) return { type: 'vip_without_membership', line: vip[0] };
    if (ms.length === 1 && !vip.length && ms[0].properties && ms[0].properties._loov_pdp) return { type: 'orphan_membership', line: ms[0] };
    return null;
  }
  // Can this cart go to checkout? (A leftover membership on its own is allowed.)
  function cartValid(cart) {
    var items = (cart && cart.items) || [];
    if (!M) return !items.some(isVipLine);
    var issue = cartIssue(cart);
    if (issue && issue.type !== 'orphan_membership') return false;
    if (membershipLines(cart).length && !memberPlan().plan) return false;
    return true;
  }

  var guestIds = {};         // product handle → available "Guest Price" variant id (0 = none)
  function guestVariantFor(line) {
    if (guestIds[line.handle] !== undefined) return Promise.resolve(guestIds[line.handle]);
    return realFetch(ROOT + 'products/' + line.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var g = p && (p.variants || []).filter(function (v) { return v.title === 'Guest Price'; })[0];
        guestIds[line.handle] = g && g.available ? g.id : 0;
        return guestIds[line.handle];
      }).catch(function () { return 0; });
  }

  var legacyMember = null;   // a legacy per-item subscription line's properties, carried to the membership
  var swappedToGuest = false;
  // Repairs are not shopper actions, so they go through postQuiet (see quietFetch).
  function fixOne(cart) {
    var issue = cartIssue(cart);
    if (!issue) return Promise.resolve(null);
    var l = issue.line, mp = memberPlan();
    if (issue.type === 'jewelry_plan') {
      // Carts from the old per-item model: the jewelry becomes one-time, the membership carries the plan.
      legacyMember = { _loov_pdp: (l.properties && l.properties._loov_pdp) || 'standard' };
      if (l.properties && l.properties._loov_circle_consent) legacyMember._loov_circle_consent = l.properties._loov_circle_consent;
      return postQuiet('cart/change.js', { id: l.key, quantity: l.quantity, selling_plan: null });
    }
    if (issue.type === 'extra_membership' || issue.type === 'orphan_membership') {
      return postQuiet('cart/change.js', { id: l.key, quantity: 0 });
    }
    if (issue.type === 'fix_membership') {
      return postQuiet('cart/change.js', { id: l.key, quantity: 1, selling_plan: mp.plan });
    }
    // Member-priced jewelry without a membership.
    if (legacyMember && mp.plan) {
      var props = legacyMember; legacyMember = null;
      return postQuiet('cart/add.js', { items: [{ id: Number(M.variant), quantity: 1, selling_plan: mp.plan, properties: props }] }).then(function () { return fetchCart(); });
    }
    // The membership was removed (or never added): back to regular prices, never member prices without it.
    return guestVariantFor(l).then(function (gid) {
      if (!gid) throw new Error('no available "Guest Price" variant for ' + l.handle);
      return postQuiet('cart/change.js', { id: l.key, quantity: 0 }).then(function () {
        return postQuiet('cart/add.js', { items: [{ id: gid, quantity: l.quantity, properties: l.properties || {} }] });
      }).then(function () { swappedToGuest = true; return fetchCart(); });
    });
  }
  function normalizeCart(cart) {
    var changed = false, n = 0;
    swappedToGuest = false;
    function step(c) {
      if (n++ > 8) return Promise.resolve(c);
      return fixOne(c).then(function (res) {
        if (res === null) return c;
        changed = true;
        return (res && res.token ? Promise.resolve(res) : fetchCart()).then(step);
      }, function (err) {
        console.error('[LOOV] Cart check could not fix the cart: ' + (err && err.message));
        return fetchCart();
      });
    }
    return step(cart).then(function (c) {
      if (changed) {
        // Let the cart drawer re-render with the corrected lines.
        /* global publish, PUB_SUB_EVENTS */
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'loov-cart-rules', cartData: c }); } catch (e) {}
      }
      if (swappedToGuest) toast('LOOV Circle was removed, so your pieces are back at regular prices.');
      return c;
    });
  }

  var refreshAgain = false;
  function refreshCart() {
    // A member purchase being added: check the cart once it's complete.
    if (addLock) return addLock.then(refreshCart);
    // A cart change while a refresh is running gets its own pass afterwards.
    if (refreshing) { refreshAgain = true; return refreshing; }
    refreshing = fetchCart().then(normalizeCart).then(function (cart) {
      cartState = cart; return cart;
    }).catch(function () { return cartState; }).then(function (c) {
      refreshing = null;
      if (refreshAgain) { refreshAgain = false; return refreshCart(); }
      return c;
    });
    return refreshing;
  }
  var refreshTimer = null;
  function scheduleRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshCart, 150); }

  // Watch cart writes from anything on the page (drawer quantity buttons, upsells, add to cart):
  // through fetch, and through resource timing as a backstop for other request types.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  (function () {
    var f = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
      var p = f.apply(window, arguments);
      if (CART_WRITE.test(String(url))) p.then(scheduleRefresh, scheduleRefresh);
      return p;
    };
  })();
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        if (list.getEntries().some(function (e) { return CART_WRITE.test(e.name); })) scheduleRefresh();
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  // Checkout check (window, capture phase, before the cart drawer and Revley). Every checkout click
  // re-reads the cart from Shopify and applies the cart rules first (a fraction of a second, no
  // extra step for the shopper); if the cart still breaks them, checkout is held, so a broken
  // membership is never sent to checkout as a one-time order.
  var bypass = false;
  function checkoutTarget(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    if (e.type === 'submit') {
      if (e.submitter && e.submitter.name === 'checkout') return t;
      if (t.querySelector && t.querySelector('[name="checkout"]')) return t;
      var action = (t.getAttribute && t.getAttribute('action')) || '';
      return /\/checkout(s)?(\/|\?|$)/.test(action) ? t : null;
    }
    return t.closest('[name="checkout"], a[href*="/checkout"]');
  }
  function gate(e) {
    if (bypass || e.defaultPrevented) return;
    if (e.type === 'click' && (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
    var target = checkoutTarget(e);
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var submitter = e.submitter || null;
    clearTimeout(refreshTimer);
    if (refreshing) refreshAgain = true;   // a pass already running may predate the latest change
    refreshCart().then(function (cart) {
      if (!cartValid(cart)) {
        console.error('[LOOV] Checkout held: the LOOV Circle membership in the cart is not set up correctly.', cartIssue(cart));
        toast('We couldn’t set up your LOOV Circle membership. Please refresh the page and try again.');
        return;
      }
      bypass = true;
      try {
        if (e.type === 'submit' && typeof target.requestSubmit === 'function') target.requestSubmit(submitter && submitter.form === target ? submitter : undefined);
        else if (typeof target.click === 'function') target.click();
      } finally { bypass = false; }
    });
  }
  window.addEventListener('click', gate, true);
  window.addEventListener('submit', gate, true);

  /* ---------- gallery ---------- */
  function initGallery(g) {
    if (g.__lv) return; g.__lv = true;
    var track = $('[data-lv-track]', g);
    var thumbs = $$('[data-lv-thumb]', g);
    var count = $('[data-lv-count]', g);
    if (!track) return;
    var slides = $$('.lv-gallery__slide', track);
    function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark() {
      var i = idx();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    var raf = null;
    track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; mark(); }); }, { passive: true });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); }); });
    mark();
  }

  /* ---------- quick add ---------- */
  var quickReady = false;
  function initQuick() {
    if (quickReady) return; quickReady = true;
    var sheet = document.getElementById('lv-quick-sheet');
    var q = { vip: null, guest: null };
    var consent = sheet ? new Consent($('[data-lv-consent]', sheet)) : null;
    function fill(btn) {
      $('[data-lv-q-img]', sheet).src = btn.getAttribute('data-image') || '';
      $('[data-lv-q-img]', sheet).alt = btn.getAttribute('data-title') || '';
      $('[data-lv-q-title]', sheet).textContent = btn.getAttribute('data-title') || '';
      $('[data-lv-q-price]', sheet).textContent = btn.getAttribute('data-member-price') || '';
      $('[data-lv-q-was]', sheet).textContent = btn.getAttribute('data-guest-price') || '';
      $('[data-lv-q-guest-price]', sheet).textContent = btn.getAttribute('data-guest-price') || '';
      $('[data-lv-q-atc-price]', sheet).textContent = btn.getAttribute('data-member-price') || '';
      $('[data-lv-q-link]', sheet).href = btn.getAttribute('data-url') || '#';
      $('[data-lv-q-status]', sheet).textContent = '';
      q.vip = btn.getAttribute('data-vip');
      q.guest = btn.getAttribute('data-guest');
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lv-quick]');
      if (!btn) return;
      e.preventDefault();
      var simple = btn.getAttribute('data-simple');
      if (simple || !sheet) {
        busy(btn, true);
        addOnce(simple || btn.getAttribute('data-guest'), 1).then(function () { busy(btn, false); return openDrawer(); })
          .catch(function (err) { busy(btn, false); toast(err.message); });
        return;
      }
      fill(btn);
      fetchCart().then(function (c) { consent.setMember(hasMembership(c)); }).catch(function () {});
      openSheet('lv-quick-sheet', btn);
    });
    if (!sheet) return;
    var atc = $('[data-lv-q-atc]', sheet);
    var guestBtn = $('[data-lv-q-guest]', sheet);
    var status = $('[data-lv-q-status]', sheet);
    atc.addEventListener('click', function (e) {
      e.preventDefault();
      busy(atc, true);
      fetchCart().then(function (cart) {
        var member = hasMembership(cart);
        consent.setMember(member);
        if (!member && !consent.ok()) { consent.fail(); return false; }
        var props = member ? null : { _loov_circle_consent: consentRecord(consent.terms && consent.terms.getAttribute('data-terms')) };
        return addMemberPurchase(q.vip, 1, 'standard', props).then(function () { consent.setMember(true); return true; });
      }).then(function (added) {
        busy(atc, false);
        if (added) { closeSheet(sheet); return openDrawer(); }
      }).catch(function (err) {
        busy(atc, false);
        status.textContent = err && err.reason ? 'Member pricing isn’t available right now. You can still buy at the regular price below.' : err.message;
        if (err && err.reason) console.error('[LOOV] Member purchase blocked: ' + (CONFIG_MESSAGES[err.reason] || err.reason) + '.');
      });
    });
    guestBtn.addEventListener('click', function (e) {
      e.preventDefault();
      busy(guestBtn, true);
      addOnce(q.guest, 1).then(function () { busy(guestBtn, false); closeSheet(sheet); return openDrawer(); })
        .catch(function (err) { busy(guestBtn, false); status.textContent = err.message; });
    });
  }

  /* ---------- review filters ---------- */
  function initFilters(wrap) {
    if (wrap.__lv) return; wrap.__lv = true;
    var chips = $$('[data-lv-filter]', wrap);
    var reviews = $$('[data-tags]', wrap);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var tag = chip.getAttribute('data-lv-filter');
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        reviews.forEach(function (r) { r.hidden = !(tag === 'all' || (r.getAttribute('data-tags') || '').split('|').indexOf(tag) !== -1); });
        var sc = $('.lv-scroller', wrap); if (sc) sc.scrollTo({ left: 0 });
      });
    });
  }

  /* ---------- scroller dots ---------- */
  function initDots(dots) {
    if (dots.__lv) return; dots.__lv = true;
    var sc = document.getElementById(dots.getAttribute('data-lv-dots'));
    if (!sc) return;
    var spans = $$('span', dots);
    function mark() {
      var max = sc.scrollWidth - sc.clientWidth;
      var i = max <= 0 ? 0 : Math.round((sc.scrollLeft / max) * (spans.length - 1));
      spans.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    }
    sc.addEventListener('scroll', mark, { passive: true });
    mark();
  }

  /* ---------- delivery estimate ---------- */
  function initArrive(el) {
    var min = Number(el.getAttribute('data-min') || 6), max = Number(el.getAttribute('data-max') || 9);
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + min); b.setDate(b.getDate() + max);
    var m = function (d) { return d.toLocaleString('en-US', { month: 'short' }); };
    el.textContent = m(a) === m(b) ? m(a) + ' ' + a.getDate() + '–' + b.getDate() : m(a) + ' ' + a.getDate() + '–' + m(b) + ' ' + b.getDate();
  }

  function init() {
    $$('[data-lv-buy]').forEach(initBuy);
    $$('[data-lv-gallery]').forEach(initGallery);
    $$('[data-lv-filters]').forEach(initFilters);
    $$('[data-lv-dots]').forEach(initDots);
    $$('[data-lv-arrive]').forEach(initArrive);
    initQuick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  refreshCart();

  window.LoovDS = Object.assign(window.LoovDS || {}, { resolvePlan: resolvePlan, revleyPlans: revleyPlans, refreshCart: refreshCart });
})();
